export default __webpack_public_path__ + "static/media/EE.2d3199d2.svg";